import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4b26c9de&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./detail.vue?vue&type=style&index=1&id=4b26c9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26c9de",
  null
  
)

export default component.exports